import { getMarketOverviewBreadcrumbsRoute } from '@/finsight/ui/common/helpers';
import { toSlug } from '@/Framework/url/helpers/toSlug';

interface ILeagueTableItemRoute {
  role: string,
  name: string,
  viewId: string,
}

export const getLeagueTableItemRoute = (queryString:string, companyRole = '') => (
  { role, name, viewId }:ILeagueTableItemRoute,
):string => {
  const roleName = (companyRole || role) === 'underwriter' ? 'underwriter' : 'rating-agency';
  return `/${ roleName }-${ viewId }-${ toSlug(name) }-league-table?${ queryString }`;
};

interface IBreadcrumbs {
  products?: string | string[],
  regions?: string | string[],
  q?: string | string[],
}

export const getBreadcrumbs = (filters:IBreadcrumbs) => [
  getMarketOverviewBreadcrumbsRoute(filters),
  {
    title: 'League Tables',
    isActive: true,
  },
];
